import React from 'react';
import { Element } from 'react-scroll';
import SectionTitle2 from '../../sectionTitle/SectionTitle2';
import { Link } from 'react-router-dom';

const AgricultureTransformation = () => {
  return (
    <>
      <Element
      name="AgricultureTransformation"
        className="datatalent-section-gap bg-white"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 col-lg-6 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-left"
                title = "Agriculture & Food Industry Transformation"
              />
              <p className="mt-4">Edge AI is transforming how farms, food producers, and agri-enterprises operate-enabling real-time decisions, optimizing resource use, and enhancing resilience in the face of climate and connectivity challenges. Our platform brings intelligence directly to the field, greenhouse, and processing floor-empowering operators to act instantly and autonomously.</p>
              <h6 className="mt-5 mb-4">Transformation Highlights</h6>
              <ul>
                <li>From Manual Monitoring → To Real-Time AI Insights</li>
                <li>From Centralized Data Dependency → To Edge Intelligence</li>
                <li>From Generic Solutions → To Configurable, Use-Case Specific Tools</li>
                <li>From High-Cost Deployments → To Scalable, Affordable Adoption</li>
              </ul>
              <Link className="edu-btn btn-primary" to="/products/m2m-edge-ai">Discover Edge AI Products</Link>
            </div>
            <div className="col-12 col-lg-6 mt-4 mt-md-0 px-0 px-md-4 d-flex flex-row flex-wrap align-items-center justify-content-center">
              <div className="d-flex flex-row flex-wrap align-items-center justify-content-center">
                <div className="col-6 p-2">
                  <div className="manufacturing-transformation-stats-card-blue p-4">
                    <h5 className="mtsc-heading mb-0">
                      +30%
                    </h5>
                    <small>Crop Yield Accuracy</small>
                  </div>
                </div>
                <div className="col-6 p-2">
                  <div className="manufacturing-transformation-stats-card-green p-4">
                    <h5 className="mtsc-heading mb-0">
                      -40%
                    </h5>
                    <small>Water & Energy Use</small>
                  </div>
                </div>
                <div className="col-6 p-2">
                  <div className="manufacturing-transformation-stats-card-purple p-4">
                    <h5 className="mtsc-heading mb-0">
                      5X
                    </h5>
                    <small>Faster Decisions</small>
                  </div>
                </div>
                <div className="col-6 p-2">
                  <div className="manufacturing-transformation-stats-card-orange p-4">
                    <h5 className="mtsc-heading mb-0">
                      -25%
                    </h5>
                    <small>Reduction in Crop Loss</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default AgricultureTransformation;